"use strict";

angular.module("vendor")
.component("btnClone", {
    templateUrl: require("./btn-clone.component.html"),
    controller: BtnCloneController,
    controllerAs: "btnCloneCtrl",
    bindings: {
        service: "<",
        referenceModel: "<",
        textButton: "="
    }
});

function BtnCloneController($scope, ModalService) {
    var _this = this;

    this.clone = function() {
        var referenceModel = _this.referenceModel;

        ModalService.showModal({
            templateUrl: require("./catalog-confirmation.modal.html"),
            controller: "CloneConfirmationController",
            controllerAs: "cloneConfirmationCtrl",
            inputs: {
                $attrs: {
                    referenceModel: referenceModel,
                    service: _this.service
                }
            }
        }).then(function(modal) {
            modal.element.modal();
            modal.element.on("hidden.bs.modal", function(e) {
                modal.element.remove();
            });
        });

    };

}



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/catalog/btn-clone/btn-clone.component.js
// module id = 936
// module chunks = 0